/* istanbul ignore file */
import { MpxResponseBaseSingle } from '../types/MpxTypes'
import { PaginationResponse } from '../types/PaginationTypes'
import {
  CreatePracticeTemplateRequest,
  PracticeTemplate,
  UpdatePracticeTemplateRequest,
} from '../types/PracticeTemplate'
import { generatePath } from '../utils'
import { getMpAgent } from './utils'

const mpAgent = getMpAgent()

const PATHS = {
  LIST: '/termset/templates',
  ENTITY: '/termset/templates/:id',
}

export const PracticeTemplatesAPI = {
  create({ programId, taskId, ...body }: CreatePracticeTemplateRequest) {
    return mpAgent
      .post<MpxResponseBaseSingle<PracticeTemplate>>(PATHS.LIST, body, {
        params: { programId, taskId },
      })
      .then(response => response?.data)
  },

  search() {
    return mpAgent
      .get<PaginationResponse<PracticeTemplate>>(PATHS.LIST)
      .then(response => response?.data)
  },

  update({ id, programId, taskId, ...rest }: UpdatePracticeTemplateRequest) {
    return mpAgent
      .put<MpxResponseBaseSingle<PracticeTemplate>>(generatePath(PATHS.ENTITY, { id }), rest, {
        params: { programId, taskId },
      })
      .then(response => response?.data)
  },

  delete(id: string) {
    return mpAgent
      .delete(generatePath(PATHS.ENTITY, { id }))
      .then(response => response?.data)
  },
}
